import { useTranslation } from '@gem/modules/i18n';

import { CommonPayload } from '../CommonPayload/CommonPayload';

export const UnsupportedPayload = ({ name }) => {
  const { t } = useTranslation();

  return (
    <CommonPayload
      name={name}
      description={t('message_type_unsupported')}
    />
  );
};
